var MODULES, NAMESPACES, registerModules;

window.Modules = {};

MODULES = ['Coupons', 'Store', 'Shared', 'EmailSubscription', 'Occasions', 'Categories'];

NAMESPACES = ['Application', 'Collections', 'Helpers', 'Models', 'Presenters', 'UI', 'Views'];

registerModules = function() {
  return _(MODULES).each(function(module) {
    Modules[module] = {};
    return _(NAMESPACES).each(function(ns) {
      return Modules[module][ns] = {};
    });
  });
};

registerModules();

module.exports = Modules;

